import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import './index.css'
import moment from "moment";

const ReloadCountBack = ({nextDate, showDesc = true,showTitle=true}) => {
    const [loading, setLoading] = useState(true)
    const {t} = useTranslation()

    const [date, setDate] = useState({
        days: '',
        hours: '',
        minutes: '',
        seconds: '',
    })
    useEffect(() => {

        if (nextDate) {
            calculateDate()

            const interval = setInterval(() => {
                calculateDate()
            }, 1000)

            return () => clearInterval(interval)
        }
    }, [nextDate])

    const calculateDate = () => {
        const dateNow = parseInt(Date.now() / 1000)
        const dateFuture = parseInt(nextDate)

        if (dateNow > dateFuture) {
            setDate({
                days: 0,
                hours: 0,
                minutes: 0,
                seconds: 0,
            })
        } else {
            let seconds = Math.floor((dateFuture - (dateNow)));
            let minutes = Math.floor(seconds / 60);
            let hours = Math.floor(minutes / 60);
            let days = Math.floor(hours / 24);

            hours = hours - (days * 24);
            minutes = minutes - (days * 24 * 60) - (hours * 60);
            seconds = seconds - (days * 24 * 60 * 60) - (hours * 60 * 60) - (minutes * 60);

            if (minutes?.toString()?.length <= 1)
                minutes = '0' + minutes

            if (seconds?.toString()?.length <= 1) {
                seconds = '0' + seconds
            }

            if (hours?.toString()?.length <= 1)
                hours = '0' + hours

            setDate({
                days,
                hours,
                minutes,
                seconds,
            })
        }

        setLoading(false)
    }

    if (loading)
        return null
    return (
        <div className="d-flex flex-column align-items-center align-self-center gap-2 pb-2">
            {
                showTitle &&
                <span className="claim-tile">{t('reload.count-back.title')}</span>
            }


            <div className="timer chromatic-ignore size-default svelte-1gvsbmk">
                <div className="item svelte-1gvsbmk">
                                <span className="digits svelte-1gvsbmk">
                                  <span
                                      className="weight-bold line-height-120pct align-left size-md text-size-md variant-highlighted with-icon-space svelte-17v69ua"
                                  >
                                    {date?.days}
                                  </span>
                                </span>{" "}
                    <span
                        className="weight-semibold line-height-120pct align-left size-default text-size-default variant-subtle with-icon-space svelte-17v69ua"
                    >
                                  {t('reload.count-back.day')}
                                </span>{" "}
                </div>
                <div className="item svelte-1gvsbmk">
                                <span className="digits svelte-1gvsbmk">
                                  <span
                                      className="weight-bold line-height-120pct align-left size-md text-size-md variant-highlighted with-icon-space svelte-17v69ua"
                                  >
                                      {date?.hours}
                                  </span>
                                </span>{" "}
                    <span
                        className="weight-semibold line-height-120pct align-left size-default text-size-default variant-subtle with-icon-space svelte-17v69ua"
                    >
                                  {t('reload.count-back.hour')}
                                </span>{" "}
                </div>
                <div className="item svelte-1gvsbmk">
                                <span className="digits svelte-1gvsbmk">
                                  <span
                                      className="weight-bold line-height-120pct align-left size-md text-size-md variant-highlighted with-icon-space svelte-17v69ua"
                                  >
                                      {date?.minutes}
                                  </span>
                                </span>{" "}
                    <span
                        className="weight-semibold line-height-120pct align-left size-default text-size-default variant-subtle with-icon-space svelte-17v69ua"

                    >
                                  {t('reload.count-back.minute')}
                                </span>{" "}
                </div>
                <div className="item svelte-1gvsbmk">
                                <span className="digits svelte-1gvsbmk">
                                  <span
                                      className="weight-bold line-height-120pct align-left size-md text-size-md variant-highlighted with-icon-space svelte-17v69ua"
                                  >
                                      {date?.seconds}
                                  </span>
                                </span>{" "}
                    <span
                        className="weight-semibold line-height-120pct align-left size-default text-size-default variant-subtle with-icon-space svelte-17v69ua"

                    >
                                  {t('reload.count-back.second')}
                                </span>{" "}
                </div>
            </div>

            {
                showDesc && <span className="reload-footer-txt">
                                    <span className="reload-description">{t('reload.count-back.description')}</span>
                                    <span
                                        className="reload-date">{moment.unix(nextDate).format('MMMM Do YYYY, h:mm:ss a')}</span>
                                </span>
            }
        </div>
    )

}


export default ReloadCountBack
